import { UserID } from "./User";

export type UserFilterID = number;

export enum DAY_PLANNER_APPOINTMENT_STATUSES_FILTERS {
  NewCarStatus = 1,
  CarCheckStatus = 2,
  DiagnoseStatus = 6,
  AannameOKStatus = 7,
  CustomerOKStatus = 4,
  CustomerAnsweredStatus = 12,
  BackOrder = 13,
  HandleCheckIn = 50,
  CarInShop = 52,
  Panic = 100
}

export enum USER_FILTER_KEYS {
  WarrantyDashboardLocationID = 1,
  WarrantyDashboardPinStatus = 2,
  AppointmentStatus = 3,
  DayplannerAppointmentStatus = 4,
  DayplannerBrandGroups = 5
}

export interface UserFilter {
  created_on: string;
  id: UserFilterID;
  filter_key_id: USER_FILTER_KEYS; // Identifier for the type of filter
  filter_value: number; // Generic argument for what this filter contains
  user_id: UserID; // User Identifier that the filter is for
}
